import { useMemo } from 'react';
import { AuthState } from '@okta/okta-auth-js';
import jwt_decode from 'jwt-decode';

function getAuthState() {
  return ((window as any).ImAuthState as AuthState | null) || null;
}

function getToken() {
  const authState = getAuthState();
  return authState?.accessToken;
}

/** The header `authorization` (Bearer token) for api requests. */
export function getAuthorizationHeader() {
  const token = getToken();
  return token ? `${token.tokenType} ${token.accessToken}` : undefined;
}

// The content of the Token
export function useDecodedToken() {
  const token = getToken();
  return useMemo(() => {
    const accessToken = token?.accessToken;
    if (accessToken) {
      return jwt_decode(accessToken) as TokenContent;
    }
  }, [token]);
}

export function useRoles() {
  const decodedToken = useDecodedToken();
  return decodedToken?.role;
}

export type Segments = {
  resellerPersonalization: string[];
  userAdbutler: string[];
  userPersonalization: string[];
};

export type TokenContent = {
  acr: string;
  appName: string;
  aud: string;
  azureAd: string;
  cid: string;
  email: string;
  environment: string;
  exp: number;
  firstName: string;
  hideNavMenu: boolean;
  iat: number;
  imPlatform: string;
  imoProfile: {
    displayUserName: string;
    distributionChannel: string;
    division: string;
    emailAddress: string;
    firstName: string;
    impersonationMode: false;
    lastName: string;
    originalResellerId: string;
    originalUserName: string;
    resellerId: string;
    salesOrganization: string;
    userId: string;
    userName: string;
    userType: string; // 10"
  };
  iss: string;
  jti: string;
  lastName: string;
  login: string;
  resellerId: string;
  resellerProspect?: boolean;
  role: string[];
  scp: string[];
  segments: Segments;
  senderId: string;
  siteCode: string;
  sub: string;
  uid: string;
  userId: string;
  ver: number;
  whiteListedFeatures: string[];
};
